import React, { useState } from 'react';
import { Main, MenuContainer } from './styles';
import { sideBarData, sideBarDataPartners, sideBarDataSuperAdmin } from '../../route-menus';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useAuthTenant, useAuthUser } from 'store/auth';
import { hasModulePermission, hasPermission } from 'utils/permission_utils';
import { getTenant } from 'utils/tenant_utils';
import { changeStatusMenu, useMenuStatus } from 'store/menu';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';
import { getBrandingForDisplay } from 'services/company-service';

export const SideBar = () => {
  const dispatch = useDispatch();
  const user = useSelector(useAuthUser);
  const selectedTenant = useSelector(useAuthTenant);
  const openMenu = useSelector(useMenuStatus);
  const navigate = useNavigate();
  const [activeMenu, setActiveMenu] = useState('');
  const { t } = useTranslation('common');

  const { data: brandingData } = useQuery(['company-branding', selectedTenant?.slug], getBrandingForDisplay, {
    staleTime: 5 * 60 * 1000,
    retry: false,
  });
  const logoUrl = brandingData?.data?.branding?.logoUrl;
  const logoMiniUrl = brandingData?.data?.branding?.logoMiniUrl;

  const handleMenus = title => {
    if (activeMenu === title) {
      setActiveMenu('');
      return;
    }
    setActiveMenu(title);
  };

  const isMenuActive = (menu, itemMenu) => {
    return activeMenu === itemMenu;
  };

  return (
    <MenuContainer className={openMenu ? 'menu-open' : 'menu-close'}>


      <Main className="menu-content">
        <img
          id="logo"
          className={'logo-open ' + (openMenu ? '' : 'd-none')}
          src={logoUrl || '/img/icons/logo.svg'}
          alt="Logo do Virtual Officer"
          style={{ cursor: 'pointer' }}
          onClick={() => dispatch(changeStatusMenu())}
        />
        <img
          id="logo-mini"
          className={'logo-close ' + (openMenu ? 'd-none' : '')}
          src={logoMiniUrl || logoUrl || '/img/icons/logo-mini.png'}
          alt="Logo do VO com apenas a letra V"
          style={{ cursor: 'pointer' }}
          onClick={() => dispatch(changeStatusMenu())}
        />

        {/* Toggle Icon - Only show when menu is open */}
           {openMenu && (
             <div
               onClick={() => dispatch(changeStatusMenu())}
               style={{
                 position: 'absolute',
                 top: '25px',
                 right: '30px',
                 zIndex: 9999,
                 cursor: 'pointer',
                 width: '20px',
                 transition: 'all 0.3s ease',
                 backgroundColor: 'transparent',
                 border: 'none',
                 outline: 'none'
               }}
               title={t('sidebar.closeMenu')}
               onMouseEnter={(e) => {
                 e.target.style.backgroundColor = 'transparent';
               }}
               onMouseLeave={(e) => {
                 e.target.style.backgroundColor = 'transparent';
               }}
             >
               <ChevronLeftIcon style={{ color: 'white', fontSize: '25px', backgroundColor: 'transparent' }} />
             </div>
           )}
        <span
          className="link"
          onClick={() => {
            navigate('/dashboard');
            if (!openMenu) dispatch(changeStatusMenu());
          }}
          title={!openMenu ? t('sidebar.dashboard') : ""}
        >
          <img src="/img/icons/home.svg" alt="Ícone de casa" />
          <p>{t('sidebar.dashboard')}</p>
        </span>
        {sideBarData.map(
          (item, i) =>
            hasModulePermission(user.permissions, item.permissions) && (
              <section key={`above-menu-${i}`}>
                <div
                  onClick={() => {
                    if (!openMenu) {
                      dispatch(changeStatusMenu());
                    }
                    handleMenus(item.title);
                  }}
                  title={!openMenu ? t(item.titleKey) : ""}
                >
                  {typeof item.icon === 'string' ? <img src={item.icon} alt={item.iconAlt} /> : item.icon}
                  {item.children ? (
                    <p>{t(item.titleKey)}</p>
                  ) : (
                    <Link
                      to={item.link}
                      onClick={() => {
                        if (!openMenu) dispatch(changeStatusMenu());
                      }}
                    >
                      <p>{t(item.titleKey)}</p>
                    </Link>
                  )}
                  {item.children && (
                    <img
                      id="dropdown"
                      className={isMenuActive(activeMenu, item.title) ? 'active' : ''}
                      src="/img/icons/arrowDown.svg"
                      alt=""
                    />
                  )}
                </div>
                {openMenu && isMenuActive(activeMenu, item.title) && (
                  <section className="wrapper" key={`itens-${item.title}`}>
                    {item.children.map(subItem =>
                      hasPermission(user.permissions, subItem.permission) ? (
                        <Link
                          key={`${subItem.permission}-${subItem.link}`}
                          className="menuLink"
                          id="subitem"
                          to={subItem.link}
                          onClick={() => {
                            if (openMenu) dispatch(changeStatusMenu());
                          }}
                        >
                          {t(subItem.titleKey)}
                        </Link>
                      ) : (
                        <></>
                      ),
                    )}
                  </section>
                )}
              </section>
            ),
        )}
        <hr />
        {getTenant() === 'vo' &&
          sideBarDataSuperAdmin.map(
            (item, i) =>
              hasModulePermission(user.permissions, item.permissions) && (
                <section key={`under-menu-${i}`}>
                  <div
                    onClick={() => {
                      if (!openMenu) {
                        dispatch(changeStatusMenu());
                      }
                      handleMenus(item.title);
                    }}
                    title={!openMenu ? t(item.titleKey) : ""}
                  >
                    {item.icon}
                    {item.children ? (
                      <p>{t(item.titleKey)}</p>
                    ) : (
                      <Link
                        to={item.link}
                        onClick={() => {
                          if (openMenu) dispatch(changeStatusMenu());
                        }}
                      >
                        <p>{t(item.titleKey)}</p>
                      </Link>
                    )}
                    {item.children && (
                      <img
                        id="dropdown"
                        className={isMenuActive(activeMenu, item.title) ? 'active' : ''}
                        src="/img/icons/arrowDown.svg"
                        alt=""
                      />
                    )}
                  </div>
                  {openMenu && isMenuActive(activeMenu, item.title) && (
                    <section className="wrapper" key={`itens-${item.title}`}>
                      {item.children.map(subItem =>
                        hasPermission(user.permissions, subItem.permission) ? (
                          <Link
                            key={`${subItem.permission}-${subItem.link}`}
                            className="menuLink"
                            id="subitem"
                            to={subItem.link}
                            onClick={() => {
                              if (openMenu) dispatch(changeStatusMenu());
                            }}
                          >
                            {t(subItem.titleKey)}
                          </Link>
                        ) : (
                          <></>
                        ),
                      )}
                    </section>
                  )}
                </section>
              ),
          )}
        {selectedTenant?.partner === true &&
          sideBarDataPartners.map(
            (item, i) =>
              hasModulePermission(user.permissions, item.permissions) && (
                <section key={`under-menu-${i}`}>
                  <div
                    onClick={() => {
                      if (!openMenu) {
                        dispatch(changeStatusMenu());
                      }
                      handleMenus(item.title);
                    }}
                    title={!openMenu ? t(item.titleKey) : ""}
                  >
                    {item.icon}
                    {item.children ? (
                      <p>{t(item.titleKey)}</p>
                    ) : (
                      <Link
                        to={item.link}
                        onClick={() => {
                          if (openMenu) dispatch(changeStatusMenu());
                        }}
                      >
                        <p>{t(item.titleKey)}</p>
                      </Link>
                    )}
                    {item.children && (
                      <img
                        id="dropdown"
                        className={isMenuActive(activeMenu, item.title) ? 'active' : ''}
                        src="/img/icons/arrowDown.svg"
                        alt=""
                      />
                    )}
                  </div>
                  {openMenu && isMenuActive(activeMenu, item.title) && (
                    <section className="wrapper" key={`itens-${item.title}`}>
                      {item.children.map(subItem =>
                        hasPermission(user.permissions, subItem.permission) ? (
                          <Link
                            key={`${subItem.permission}-${subItem.link}`}
                            className="menuLink"
                            id="subitem"
                            to={subItem.link}
                            onClick={() => {
                              if (openMenu) dispatch(changeStatusMenu());
                            }}
                          >
                            {t(subItem.titleKey)}
                          </Link>
                        ) : (
                          <></>
                        ),
                      )}
                    </section>
                  )}
                </section>
              ),
          )}
        <span
          className="link"
          onClick={() => {
            navigate('/user-notifications');
            if (openMenu) dispatch(changeStatusMenu());
          }}
          title={!openMenu ? t('sidebar.notifications') : ""}
        >
          <img src="/img/icons/bell.svg" alt="imagem de um sino" />
          <p>{t('sidebar.notifications')}</p>
        </span>
        <span className="link" title={!openMenu ? t('sidebar.help') : ""}>
          <img src="/img/icons/help3.svg" alt="" />
          <p>{t('sidebar.help')}</p>
        </span>
      </Main>
    </MenuContainer>
  );
};
